import React from "react";

const StorageListener = () => null;

export default StorageListener;
